module.exports = __webpack_public_path__ + "static/scale-model-of-usda-forest-service-in-tallahassee-florida-807c51866199108d52b26d12bebada15.png";